import Plus from '@/images/plus.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';
import Button, { ButtonProps } from './Button';

const CreateButton = styled(Button)`
    padding: 0.75rem 3rem;
`;

function LibraryAddButton({ children, ...props }: ButtonProps) {
    const theme = useTheme();

    return (
        <CreateButton {...props} startIcon={<MaskedIcon color={theme.colors.black.main} src={Plus} size="14px" />}>
            {children}
        </CreateButton>
    );
}

export default LibraryAddButton;
